import { useState } from 'react';
import { Copy, Download, Check } from 'lucide-react';
import ToolLayout from '../../components/dev-tools/ToolLayout';
import { copyToClipboard, downloadFile } from '../../utils/clipboard';

export default function Base64Encode() {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [copied, setCopied] = useState(false);

  const encodeText = () => {
    try {
      const encoded = btoa(unescape(encodeURIComponent(input)));
      setOutput(encoded);
    } catch (err) {
      console.error('Encoding error:', err);
    }
  };

  const handleCopy = async () => {
    if (output) {
      const success = await copyToClipboard(output);
      if (success) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    }
  };

  const handleDownload = () => {
    if (output) {
      downloadFile(output, 'encoded.txt', 'text/plain');
    }
  };

  return (
    <ToolLayout
      title="Base64 Encoder"
      description="Encode text or files to Base64 format"
    >
      <div className="space-y-6">
        {/* Input */}
        <div className="card">
          <h3 className="mb-3 font-semibold text-gray-900 dark:text-gray-50">Input</h3>
          <textarea
            value={input}
            onChange={e => setInput(e.target.value)}
            placeholder="Enter text to encode..."
            className="mb-4 h-48 w-full rounded-lg border border-gray-300 bg-white p-4 font-mono text-sm text-gray-900 placeholder-gray-400 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder-gray-500 dark:focus:border-primary-400"
          />

          <div className="flex flex-wrap gap-3">
            <button onClick={encodeText} className="btn-primary">
              Encode Text
            </button>
          </div>
        </div>

        {/* Output */}
        <div className="card">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="mb-3 font-semibold text-gray-900 dark:text-gray-50">Base64 Output</h3>
            {output && (
              <div className="flex gap-2">
                <button
                  onClick={handleCopy}
                  className="flex items-center gap-1 rounded-lg px-3 py-1.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
                >
                  {copied ? <Check size={16} /> : <Copy size={16} />}
                  {copied ? 'Copied!' : 'Copy'}
                </button>
                <button
                  onClick={handleDownload}
                  className="flex items-center gap-1 rounded-lg px-3 py-1.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
                >
                  <Download size={16} />
                  Download
                </button>
              </div>
            )}
          </div>

          <pre className="h-48 w-full overflow-auto rounded-lg border border-gray-300 bg-gray-50 p-4 font-mono text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200">
            {output || 'Encoded output will appear here...'}
          </pre>
        </div>
      </div>
    </ToolLayout>
  );
}
